import React, { useState,useEffect } from "react";
import { Grid, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../constants";
// import ApplicationTrendsChart from "./ApplicationTrendsChart";
// import ApplicationsReview from "../../components/Dashboard/ApplicationsReview";
import ApplicationStatus from "../../components/Dashboard/ApplicationStatus";
import DelayStatus from "../../components/Dashboard/DelayStatus";
import CustomDateInput from "../../components/CustomDateInput/CustomDateInput";
import { selectDateFilter } from "../../redux/selectors/dateFilterSelector";
import { API } from "../../apis/api";

const useStyles = makeStyles((theme) => ({
  dashboardContainer: {
    paddingTop: theme.spacing(2),
    position: "relative",
  },
  legalFooter: {
    fontSize: "9px",
    color: "#999999",
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    fontFamily: "'Be Vietnam Pro', sans-serif",
    padding: theme.spacing(2),
    marginTop: theme.spacing(4),
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      bottom: "4px",
      right: "10px",
      marginBottom: "10px",
    },
  },
}));

  // API configuration
const API_BASE_URL = "/ticket/dashboard/";
const DELAY_API_URL= "/ticket/delayed-ticket-count/"
 
const fetchData = async (startDate, endDate,userId) => {
  try {
    const fromDate = startDate || "2024-06-05T05:30:00Z";
    const toDate = endDate || new Date();
 
    const response = await API.post(
      API_BASE_URL,
      {
        ticket_status: "",
        from_datetime: fromDate,
        to_datetime: toDate,
        sub:userId
      },
    );
 
    return response.data;
  } catch (error) {
    console.error("Error fetching tickets:", error);
    throw error;
  }
};

const fetchDelayData = async (startDate, endDate, userId) => {
  try {
    const fromDate = startDate || "2024-06-05T05:30:00Z";
    const toDate = endDate || "2025-07-29T23:59:59Z";
    const payload = {
      ticket_status: "",
      from_datetime: fromDate,
      to_datetime: toDate,
      sub: userId,
    };

    const response = await API.post(DELAY_API_URL, payload);

    return response.data;
  } catch (error) {
    console.error("Error fetching tickets:", error);
    throw error;
  }
};


const Dashboard = () => {
  const classes = useStyles();
  const history = useHistory();
  const { isAuditor,userId, isRTA }=useSelector(state=>state.auth.user)
  const [loading,setLoading]= useState(false) 
  const [dashboardData,setDashboardData]=useState(null)
  const [delayDashboardData,setDelayDashboardData]=useState(null)

  const {startDate,endDate}=useSelector(selectDateFilter)

  // Redirect RTA users to their default route
  useEffect(() => {
    if (isRTA) {
      history.replace(ROUTES.IEPFReport);
    }
  }, [isRTA, history]);

   const formatDateForAPI = (date) => {
    if (!date) return null;
    const dateObj = new Date(date);
    return dateObj.toISOString();
  };

   useEffect(() => {
      const loadTickets = async () => {
        setLoading(true)
        try {
          // setLoading(true);
          // setError(null);

          // Format dates for API call
          const formattedStartDate = formatDateForAPI(startDate);
          const formattedEndDate = formatDateForAPI(endDate);

          const [apiData, DelayApiData] = await Promise.all([
            fetchData(formattedStartDate, formattedEndDate,userId),
            fetchDelayData(formattedStartDate, formattedEndDate,userId),
          ]);

          setDashboardData(apiData);
          setDelayDashboardData(DelayApiData);
        } catch (err) {
          console.log("Failed to load tickets:", err);
          setLoading(false)
          // setError(err.message);
        } finally {
          setLoading(false);
        }
      };
   
      loadTickets();
    }, [startDate, endDate, userId]); // Re-fetch when date filter changes
   
  // Don't render dashboard content for RTA users (redirecting)
  if (isRTA) {
    return null;
  }

  return (
    <Box className={classes.dashboardContainer}>
      <Grid container >
        <Grid item>
          <Box mb={2}>
          <CustomDateInput/>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        {/* <Grid item xs={12} lg={6}>
          <ApplicationsReview dashboardData={dashboardData.data}/>
        </Grid>
        <Grid item xs={12} lg={6}> 
          <ApplicationTrendsChart />
        </Grid> */}
        <Grid item xs={12}>
          <ApplicationStatus dashboardApiStatusData={dashboardData} loader={loading}/>
        </Grid>
        {isAuditor && (
        <Grid item xs={12}>
          <DelayStatus dashboardDelayStatusData={delayDashboardData} loader={loading}/>
        </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default Dashboard;
